exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.loader-container[data-v-db82c4ec] {\n  width: 100%;\n  text-align: center;\n  padding-top: 15%;\n}\n.looping-rhombuses-spinner[data-v-db82c4ec] {\n  display: inline-block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-db82c4ec","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/inventory/inventory.vue
// module id = 653
// module chunks = 0